import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Pagination } from '@shared/models/pagination.model';
import { BaseService } from '@shared/services/base.service';

import { MaterialRequestListContent, MaterialRequestListSearchCriteria } from '../model/material-request-list.model';
import { MaterialRequestViewResponse } from '../model/material-request-view.model';

@Injectable({
  providedIn: 'root'
})
export class MaterialService extends BaseService {
  public override headers: HttpHeaders;

  constructor(private readonly http: HttpClient) {
    super();
    this.envService = this.env.services.material;
    this.headers = new HttpHeaders(this.envService.headers);
  }

  getMaterialRequestList(criteria: MaterialRequestListSearchCriteria) {
    const params = this.getParams(criteria);
    const url = this.getFullUrlWithStoreNo(this.envService.requestList);

    return this.http.get<Pagination<MaterialRequestListContent>>(url, {
      headers: this.loaderHeaders(null),
      observe: 'body',
      params
    });
  }

  viewMaterialRequest(docNo: string) {
    const url = this.getFullUrlWithStoreNo(this.envService.requestView, {
      docNo
    });

    return this.http.get<MaterialRequestViewResponse>(url, {
      headers: this.loaderHeaders(null),
      observe: 'body'
    });
  }
}
